import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Fade from "@mui/material/Fade/Fade";
import Modal from "@mui/material/Modal/Modal";
import Typography from "@mui/material/Typography/Typography";
import { LoadingModalProps } from "../models";


export const LoadingModal: React.FC<LoadingModalProps> = ({ openLM, messageLM }:LoadingModalProps) => {
    return (
      <Modal
        open={openLM}
        closeAfterTransition
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Fade in={openLM}>
          <div style={{ display: 'flex', flexDirection:'column' ,alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress color="primary" />
            <Typography variant="subtitle1" mt={2} style={{ marginLeft: '10px',color: '#ffffff',fontSize: '1.5rem' }}>
              {messageLM}
            </Typography>
          </div>
        </Fade>
      </Modal>
    );
  };
  